import { isThereNewVersion } from './isThereNewVersion';

export const checkCacheStatus = async (
  metaFileDirectory: string,
  currentVersion: string,
): Promise<{ shouldUpdate: boolean; metaVersion?: string }> => {
  try {
    const directory =
      !metaFileDirectory || metaFileDirectory === '.' ? '' : metaFileDirectory;
    const response = await fetch(`${directory}/meta.json`, {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache',
      },
    });
    const { version: metaVersion } = await response.json();

    const shouldUpdate = isThereNewVersion(metaVersion, currentVersion);

    return {
      shouldUpdate,
      metaVersion,
    };
  } catch (error) {
    console.error('Failed to check cache status:', error);
    return {
      shouldUpdate: false,
    };
  }
};
